import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  error: null,
  data: {}
};

export const getPricing = createAsyncThunk(
  "pricing/getPricing",
  async (_, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(
        `/management`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updatePricing = createAsyncThunk(
  "pricing/updatePricing",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/management`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const pricingSlice = createSlice({
  name: "pricing",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getPricing.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    })
      .addCase(getPricing.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
      })
      .addCase(getPricing.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updatePricing.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePricing.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
      })
      .addCase(updatePricing.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});


export default pricingSlice.reducer;